import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/happy-pets/hero.webp'
import _imports_1 from '@/assets/happy-pets/p-1.webp'
import _imports_2 from '@/assets/happy-pets/p-2.webp'
import _imports_3 from '@/assets/happy-pets/p-3.webp'
import _imports_4 from '@/assets/happy-pets/p-4.webp'
import _imports_5 from '@/assets/happy-pets/p-5.webp'
import _imports_6 from '@/assets/happy-pets/p-6.webp'
import _imports_7 from '@/assets/happy-pets/p-7.webp'
import _imports_8 from '@/assets/happy-pets/p-8.webp'
import _imports_9 from '@/assets/grass-wide.webp'


const _hoisted_1 = { class: "flex flex-col mx-auto gap-y-16 md:gap-y-32 max-w-ful overflow-x-hidden" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col gap-10 md:gap-4 md:flex-row items-centerw-full max-w-full md:max-w-[95%] lg:max-w-[1120px] mx-auto mt-10 md:mt-20 px-7 md:px-0\"><img src=\"" + _imports_0 + "\" class=\"md:hidden\"><div class=\"md:max-w-[320px] lg:max-w-[360px] flex flex-col gap-6\"><div class=\"font-bold text-[32px] md:text-[52px] text-secondary-gray md:text-green leading-tight font-georgian\"> The Perfect Pet Space </div><div class=\"text-sm leading-relaxed\"><span class=\"text-light-green font-bold\">Perfect Green installs the highest quality artificial ProGreen turf for dogs.</span><br><br><span class=\"text-primary-gray\"> ProGreen has been innovating and improving synthetic dog turf since 1987. ProGreen pet turf features <span class=\"text-light-green font-bold\">low pile heights </span> and an <span class=\"text-light-green font-bold\">innovative backing </span>that makes waste cleanup easy. This turf can also handle immense amounts of traffic and play from your four-legged friends, providing you peace-of-mind that your turf investment will stand the test of time. </span></div></div><div class=\"ml-auto w-full max-w-[670px] hidden md:block\"><img src=\"" + _imports_0 + "\"></div></div>", 1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-2.5" }, [
  /*#__PURE__*/_createElementVNode("div", null, " The most important feature to consider before purchasing artificial turf for dogs is how well it drains. Drainage efficiency is ultimately what eliminates mud and puddles from a yard. The elimination of rain water pooling in specific areas is one of the biggest perks of synthetic dog turf. In addition, drainage is extremely important for eliminating the complications of odors caused by pet urine. "),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" Most turf available on the market has perforated backings, which means pet urine has to make its way to drainage holes before passing through the turf. It is not uncommon for liquids, including urine, to rest in the areas between these drainage holes which results in a terrible odor. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" All of our canine products feature our "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-light-green font-bold" }, "patent-pending ProFlow technology,"),
    /*#__PURE__*/_createTextVNode(" a non-perforated backing that increases "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-light-green font-bold" }, "drainage capacity by over 100%"),
    /*#__PURE__*/_createTextVNode(" and allows pet urine to drain through any point of the turf. With a flow-through backing like ProFlow, the urine does not need to find these holes to drain; it just drains right through. ")
  ])
], -1)
const _hoisted_4 = { class: "hidden md:block" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-light-green font-bold" }, "patent-pending ProFlow technology,", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-light-green font-bold" }, "drainage capacity by over 100%", -1)
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col items-center gap-6 md:gap-10\"><div class=\"md:uppercase font-bold font-georgian text-2xl md:text-[42px] text-green\"> Our Work </div><div class=\"grid grid-cols-2 md:grid-cols-4 gap-1\"><img src=\"" + _imports_1 + "\" class=\"transition-all hover:scale-105 cursor-pointer hidden md:block\"><img src=\"" + _imports_2 + "\"><img src=\"" + _imports_3 + "\"><img src=\"" + _imports_4 + "\"><img src=\"" + _imports_5 + "\"><img src=\"" + _imports_6 + "\"><img src=\"" + _imports_7 + "\"><img src=\"" + _imports_8 + "\" class=\"transition-all hover:scale-105 cursor-pointer hidden md:block\"></div></div>", 1)
const _hoisted_12 = { class: "relative w-full max-w-full" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 bottom-0 left-0 right-0 items-center z-0 hidden md:flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_9,
    class: "w-full h-60"
  })
], -1)
const _hoisted_14 = { class: "flex flex-col items-center gap-10 z-10 relative max-w-full" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl text-green md:text-[32px] leading-normal font-bold font-georgian text-center" }, [
  /*#__PURE__*/_createTextVNode(" Our most popular "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("pet space solutions ")
], -1)
const _hoisted_16 = { class: "flex md:gap-2 lg:gap-4 flex-wrap items-center justify-center" }

import TaggedWidget from "@/components/common/tagged-wedget.vue";
import SolutionCard from "@/components/family-space/solution-card.vue";
// import FilledButton from "@/components/common/filled-button.vue";
import GrassBgMobile from "@/components/common/grass-bg-mobile.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HappyPets',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(GrassBgMobile, { class: "md:hidden" }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(TaggedWidget, null, {
        default: _withCtx(() => [
          _createTextVNode("The most important feature to consider before purchasing artificial turf for dogs is how well it drains. Drainage efficiency is ultimately what eliminates mud and puddles from a yard. The elimination of rain water pooling in specific areas is one of the biggest perks of synthetic dog turf. In addition, drainage is extremely important for eliminating the complications of odors caused by pet urine. "),
          _hoisted_5,
          _hoisted_6,
          _createTextVNode(" Most turf available on the market has perforated backings, which means pet urine has to make its way to drainage holes before passing through the turf. It is not uncommon for liquids, including urine, to rest in the areas between these drainage holes which results in a terrible odor. "),
          _hoisted_7,
          _hoisted_8,
          _createTextVNode(" All of our canine products feature our "),
          _hoisted_9,
          _createTextVNode(" a non-perforated backing that increases "),
          _hoisted_10,
          _createTextVNode(" and allows pet urine to drain through any point of the turf. With a flow-through backing like ProFlow, the urine does not need to find these holes to drain; it just drains right through.")
        ]),
        _: 1
      })
    ]),
    _hoisted_11,
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createVNode(SolutionCard, { size: "sm" }, {
            title: _withCtx(() => [
              _createTextVNode("Natural Real Supreme 75")
            ]),
            price: _withCtx(() => [
              _createTextVNode("$8.50")
            ]),
            height: _withCtx(() => [
              _createTextVNode("1.75”")
            ]),
            weight: _withCtx(() => [
              _createTextVNode("75 oz")
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Introducing the ProGreen Natural Real Supreme 75 - the epitome of luxury and realism in artificial grass. With a lush pile height of 1.75 inches and a weight of 75 ounces, this premium turf is designed to provide the perfect blend of softness and durability. ")
            ]),
            _: 1
          }),
          _createVNode(SolutionCard, { size: "sm" }, {
            title: _withCtx(() => [
              _createTextVNode("K9 Deluxe")
            ]),
            price: _withCtx(() => [
              _createTextVNode("$7.50")
            ]),
            height: _withCtx(() => [
              _createTextVNode("1.125”")
            ]),
            weight: _withCtx(() => [
              _createTextVNode("60 oz")
            ]),
            default: _withCtx(() => [
              _createTextVNode(" ProGreen K9 Deluxe - the ultimate solution for pet-friendly artificial grass. With a robust pile height of 1.125 inches and a weight of 60 ounces, this turf is specifically engineered to meet the needs of pet owners. ")
            ]),
            _: 1
          }),
          _createVNode(SolutionCard, { size: "sm" }, {
            title: _withCtx(() => [
              _createTextVNode("K9 Champion DF")
            ]),
            price: _withCtx(() => [
              _createTextVNode("$8.50")
            ]),
            height: _withCtx(() => [
              _createTextVNode("1.25”")
            ]),
            weight: _withCtx(() => [
              _createTextVNode("90 oz")
            ]),
            default: _withCtx(() => [
              _createTextVNode(" ProGreen K9 Champion DF - the premier choice for pet-friendly artificial grass. Featuring a pile height of 1.25 inches and a weight of 90 ounces, this dual-fiber turf is designed for maximum durability and resilience. ")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})